import React from "react";
import styled from "styled-components";

function Page5Pc() {
  return (
    <MainContainer>
      <Title>브랜드만의 컨셉을 담은 주얼리를 생산해보세요</Title>
      <Btn
        onClick={() => {
          window.open("http://pf.kakao.com/_UCUzG");
        }}
      >
        <BtnText>카카오톡 상담하기</BtnText>
      </Btn>
      <Ellipse2257 />
      <Ellipse2256 />
    </MainContainer>
  );
}

export default Page5Pc;
const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #070707;
  overflow: hidden;
  position: relative;
`;
const Title = styled.p`
  color: #fff;
  font-family: Pretendard;
  font-size: 50px;
  font-style: normal;
  font-weight: 700;
  line-height: 60px; /* 120% */
  margin-top: 126px;
`;
const Btn = styled.div`
  cursor: pointer;
  display: flex;
  padding: 20px 38px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 100px;
  background: linear-gradient(90deg, #ff5aa9 0%, #ff8542 100%);
  margin-top: 40px;
  margin-bottom: 146px;
`;
const BtnText = styled.p`
  color: #fff;
  font-family: Pretendard;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px; /* 140% */
`;
const Ellipse2257 = styled.div`
  position: absolute;
  left: -200px;
  width: 860px;
  height: 860px;
  flex-shrink: 0;
  border-radius: 860px;
  opacity: 0.3;
  background: radial-gradient(
    38.46% 38.46% at 50% 50%,
    #cd68fc 0%,
    rgba(229, 66, 255, 0) 100%
  );
  filter: blur(50px);
`;
const Ellipse2256 = styled.div`
  position: absolute;
  right: -200px;
  width: 740px;
  height: 740px;
  flex-shrink: 0;
  border-radius: 740px;
  opacity: 0.3;
  background: radial-gradient(
    38.46% 38.46% at 50% 50%,
    #ff7e47 0%,
    rgba(255, 157, 66, 0) 100%
  );
  filter: blur(50px);
  transform: translateY(-400px);
`;
